import {Validator} from '@/type/validation/result';
import { 必須入力, 日付書式 } from '@/type/validation/validator';

export interface 卸別入出庫集計依頼型 {
  集計期間From: Date;
  集計期間To: Date;
}

export interface 卸別入出庫集計結果型 {
  卸別入出庫集計結果一覧: 卸別入出庫集計型[];
  アラートメッセージ: string;
}

export interface 卸別入出庫集計型 {
  卸コード: string;
  卸名: string;
  入庫金額: number;
  出庫金額: number;
}

export interface 品目別入出庫表示依頼型 {
  卸コード: string | null;
  集計期間From: Date;
  集計期間To: Date;
}

export interface 品目別入出庫集計型 {
  卸名: string;
  商品区分: string;
  使用区分: string;
  メーカー名: string;
  商品名: string;
  規格容量: string;
  入庫数: number;
  入庫金額: number;
  出庫数: number;
  出庫金額: number;
}

export interface 卸型 {
  卸コード: string;
  卸名: string;
}

export const 卸別入出庫集計条件バリデータ一覧: Validator[] = [
  {
    name: '集計期間From',
    constraints: [
      {method: 必須入力, message: '集計期間Fromは必須項目です'},
      {method: 日付書式, message: '集計期間Fromの書式が不正です'},
    ],
  },
  {
    name: '集計期間To',
    constraints: [
      {method: 必須入力, message: '集計期間Toは必須項目です'},
      {method: 日付書式, message: '集計期間Toの書式が不正です'},
    ],
  },
];
